import { render } from "./ShortcutHelp.vue?vue&type=template&id=3e089203&scoped=true"
import script from "./ShortcutHelp.vue?vue&type=script&lang=js"
export * from "./ShortcutHelp.vue?vue&type=script&lang=js"

import "./ShortcutHelp.vue?vue&type=style&index=0&id=3e089203&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e089203"]])

export default __exports__